import { alpha2List as countryList } from './country-alpha2';

const defaultCountry = countryList.AR;
const validCountries = [...Object.values(countryList)];

const isUnitedStates = () => {
  return window.location.pathname.startsWith('/us/');
};

const isMexico = () => {
  return window.location.pathname.startsWith('/mx/');
};

/**
 * Resolve the current domain country (also works on server side rendering)
 */
export const domainResolver = () => {
  if (!window) {
    return defaultCountry;
  }

  if (isUnitedStates()) {
    return countryList.US;
  }

  if (isMexico()) {
    return countryList.MX;
  }

  const hostnameParts = window.location.hostname.split('.');

  const domainCountry = validCountries.find((country) =>
    hostnameParts.some((part) => {
      let urlCountry;
      if (part === 'dev-br' || part === 'test-br' || part === 'uat-br') {
        urlCountry = 'br';
      } else {
        urlCountry = part;
      }
      return urlCountry === country;
    }),
  );

  if (!validCountries.includes(domainCountry)) {
    return defaultCountry;
  }

  return domainCountry;
};
